<template>
  <div class="search-bar search-sm">
    <!-- <div class="da-options">
          <span v-if="selectedDeliveryAreaOption !== 'daSelected'"> Search delivery area below - or - </span>
          <a href="#" @click.prevent="useDeliveryAreaSelector">
            <span v-if="selectedDeliveryAreaOption !== 'daSelected'">Pick</span>
            <span v-else>Change</span>
            Delivery Area
          </a>
        </div> -->
    <form
      class="form-inline default-form"
      v-if="selectedDeliveryAreaOption == 'googleMaps'"
    >
      <div class="form-group address-search">
        <v-select
          @search="fetchOptions"
          :filterable="false"
          :options="search_items"
          v-model="customerAddress"
        >
          <template slot="option" slot-scope="option">
            <div class="marker" @click="openSearchLocationModal">
              <svg width="15" height="15" fill="gray">
                <use xlink:href="#marker" />
              </svg>
            </div>
            {{ option.label }}
          </template>
          {{ customerFullAddress }}
          <template slot="no-options">
            {{
              _T('Type to find where do you want your order to be delivered')
            }}
          </template>
        </v-select>
        <div class="location-arrow" @click="openSearchLocationModal">
          <svg class="img-fluid" fill="none">
            <use xlink:href="#locate_position" />
          </svg>
        </div>
      </div>
    </form>
    <customer-location ref="CustomerLocation" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import CustomerLocation from '@/components/Modals/CustomerLocation'
import { gmapApi } from 'vue2-google-maps'
import 'vue-select/dist/vue-select.css'
import vSelect from 'vue-select'

export default {
  name: 'SearchBrands',
  components: {
    CustomerLocation,
    vSelect,
  },
  props: {
    btnText: {
      type: String,
      default: 'Find',
    },
  },
  computed: {
    ...mapGetters([
      '_T',
      'customerPosition',
      'selectedCountry',
      'customerFullAddress',
      'customer_addresses',
      'selectedDeliveryAreaOption',
    ]),
    customerAddress: {
      get() {
        if (this.setting_value == false) {
          if (this.customer_addresses) {
            for (var addr of this.customer_addresses) {
              if (
                addr.location_coordinates.lat ==
                  this.customerPosition.coordinates.lat &&
                addr.location_coordinates.lng ==
                  this.customerPosition.coordinates.lng
              ) {
                var formatedAddress = []
                if (addr.flat_number) formatedAddress.push(addr.flat_number)
                if (addr.building) formatedAddress.push(addr.building)
                if (addr.street) formatedAddress.push(addr.street)
                if (addr.city) formatedAddress.push(addr.city)
                return this._T('Saved Address:') + formatedAddress.join(', ')
              }
            }
          }
          return this.customerFullAddress
        } else {
          return ''
        }
      },
      set(value) {
        this.setPlace(value)
      },
    },
  },
  data() {
    return {
      autocomplete_service: null,
      search_items: [],
      setting_value: false,
    }
  },
  mounted() {
    var component = this
    this.$gmapApiPromiseLazy().then(() => {
      component.$nextTick(() => {
        var gm = gmapApi()
        component.autocomplete_service = new gm.maps.places.AutocompleteService()
        component.places_service = new gm.maps.places.PlacesService(
          document.createElement('div')
        )
      })
    })
    var results = []
    if (this.customer_addresses) {
      for (var addr of this.customer_addresses) {
        var formatedAddress = []
        if (addr.flat_number) formatedAddress.push(addr.flat_number)
        if (addr.building) formatedAddress.push(addr.building)
        if (addr.street) formatedAddress.push(addr.street)
        if (addr.city) formatedAddress.push(addr.city)
        results.push({
          value: addr.location_coordinates,
          label: this._T('Saved Address:') + formatedAddress.join(', '),
          is_google: false,
        })
      }
    }
    component.search_items = results
  },
  methods: {
    fetchOptions(search, loading) {
      loading(true)
      var component = this
      if (search) {
        this.autocomplete_service.getPlacePredictions(
          {
            input: search,
            // componentRestrictions: {country: this.selectedCountry}
          },
          (predictions, status) => {
            if (status == gmapApi().maps.places.PlacesServiceStatus.OK) {
              var results = []
              predictions.forEach(function(prediction) {
                results.push({
                  value: prediction.place_id,
                  label: prediction.description,
                  is_google: true,
                })
              })

              if (this.customer_addresses) {
                for (var addr of this.customer_addresses) {
                  var formatedAddress = []
                  if (addr.flat_number) formatedAddress.push(addr.flat_number)
                  if (addr.building) formatedAddress.push(addr.building)
                  if (addr.street) formatedAddress.push(addr.street)
                  if (addr.city) formatedAddress.push(addr.city)
                  results.push({
                    value: addr.location_coordinates,
                    label:
                      this._T('Saved Address:') + formatedAddress.join(', '),
                    is_google: false,
                  })
                }
              }
              component.search_items = results
            }
            loading(false)
          }
        )
      } else {
        var results = []
        if (this.customer_addresses) {
          for (var addr of this.customer_addresses) {
            var formatedAddress = []
            if (addr.flat_number) formatedAddress.push(addr.flat_number)
            if (addr.building) formatedAddress.push(addr.building)
            if (addr.street) formatedAddress.push(addr.street)
            if (addr.city) formatedAddress.push(addr.city)
            results.push({
              value: addr.location_coordinates,
              label: this._T('Saved Address:') + formatedAddress.join(', '),
              is_google: false,
            })
          }
        }
        component.search_items = results
        loading(false)
      }
    },
    setPlace(place) {
      if (place == null) {
        this.$store.dispatch('resetAddress')
      } else {
        if (place.is_google) {
          var that = this
          that.setting_value = true
          this.places_service.getDetails({ placeId: place.value }, function(
            results,
            status
          ) {
            if (status == gmapApi().maps.places.PlacesServiceStatus.OK) {
              that.$store.dispatch('setCustomerPlace', results)
            }
            that.setting_value = false
          })
        } else {
          var that = this
          that.setting_value = true
          this.$gmapApiPromiseLazy().then(() => {
            const geocoder = new google.maps.Geocoder()
            geocoder.geocode(
              {
                location: place.value,
                language: 'en',
              },
              (results, status) => {
                if (status === 'OK') {
                  that.$store.dispatch('setCustomerPlace', results[0])
                  that.setting_value = false
                }
              }
            )
          })
        }
      }
    },
    openSearchLocationModal() {
      this.$bvModal.show('customer-location')
    },
    useDeliveryAreaSelector() {
      this.$store.commit('SET_SELECT_DELIVERY_AREA_OPTION', 'selectDA')
    },
  },
}
</script>

<style lang="scss">
.pac-container {
  &:after {
    /* Disclaimer: not needed to show 'powered by Google' if also a Google Map is shown */

    background-image: none !important;
    height: 0px;
  }
}

.vs__search {
  width: auto !important;
}

.filter-panel {
  .search-bar {
    width: 100%;
    margin-bottom: $px15;

    form {
      display: flex;
      align-items: center;

      .form-group {
        margin-bottom: 0;
        position: relative;

        .v-select {
          width: 100%;

          .vs__dropdown-toggle {
            margin-left: $px20;
            border: 0px;
          }
          .vs__selected-options {
            height: auto;
            min-height: 3rem;
          }
          ul {
            border: 0px;
            padding-left: $px8;
            padding-right: $px8;
          }

          .marker {
            position: absolute;
            left: $px10;
          }
        }

        .vs--single.vs--open .vs__selected {
          display: none;
        }

        input {
          margin-top: 0;
          border: none !important;

          &.pac-target-input {
            width: calc(100% - 2rem) !important;
          }
        }

        .location-arrow {
          position: absolute;
          left: $px3;
          padding: $px3;
          top: 50%;
          transform: translateY(-50%);
          line-height: 1;
          cursor: pointer;

          svg {
            width: $px16;
            height: $px16;
          }
        }
      }

      ::placeholder {
        color: $light-font;
      }
    }
  }
}
.body-rtl {
  .v-select {
    .vs__dropdown-toggle {
      .vs__actions {
        padding: 4px 24px 0 3px;
      }
    }
  }
}

.da-options {
  padding: 12px;
}
</style>
<style lang="sass" scoped></style>
